class TooltipUtils {
  constructor(selector) {
    this.selector = selector
  }

  handleModalEvents() {
    document.querySelectorAll(this.selector).forEach(this.create.bind(this))
  }

  destroy($elem) {
    $elem.tooltip.destroy()
  }
}

export default TooltipUtils
